function initMyawards() {
    const $awards = $("#myawards");
    if (!$awards.length || $awards.hasClass("myawards-init")) return;
    $awards.addClass("myawards-init");

    const $list = $awards.find(".myawards-list");
    const $items = $list.children(".myaward");
    if (!$items.length) return;

    // Změřit šířku jednoho cyklu (originál položky)
    let cycleWidth = 0;
    $items.each(function () {
        cycleWidth += this.getBoundingClientRect().width;
    });

    const containerWidth = $awards[0].getBoundingClientRect().width;

    // Pokud se vše vejde do viewportu, žádná animace — jen vycentrovat
    if (cycleWidth <= containerWidth) {
        $list.addClass("myawards-list--static");
        return;
    }

    // Cyklus přesahuje viewport — duplikujeme jednou pro plynulou nekonečnou smyčku (0% → -50%)
    $items.clone().appendTo($list);

    // Rychlost animace v px/s — větší = pomalejší
    const SPEED = 60;
    const duration = cycleWidth / SPEED;
    $list[0].style.setProperty("--myawards-duration", duration + "s");

    $list.addClass("myawards-list--marquee");
}

$(document).ready(function () {
    if ($("#products-2").length && $("#myawards").length) {
        $("#myawards").insertAfter("#products-2");
    }
    initMyawards();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initMyawards();
});
